var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "portal",
    { attrs: { to: "featured-offers-modal-portal" } },
    [
      _c("modal", { ref: "modal", on: { close: _vm.onModalClose } }, [
        _c(
          "div",
          {
            staticClass: "featured-offers__content",
            style: { top: _vm.topOffset + "px" },
            attrs: { slot: "content" },
            slot: "content"
          },
          [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "featured-offers" },
                _vm._l(_vm.blocks, function(offer) {
                  return _c("featured-offer", {
                    key: offer.id,
                    attrs: { offer: offer }
                  })
                }),
                1
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }